const Routes = {
  HOME: "/",
  FINANCIAL_PRODUCTS: "/financial-products",
  BLOG: "https://blog.mahila.money/",
  APPLY_LOAN: "/apply-loan",
  MAHILA_LOAN: "/mahila-loan",
  MM_PLAY_STORE_URL:
    "https://play.google.com/store/apps/details?id=com.sm.mahilamoney",
  FREQUENTLY_ASKED_QUESTIONS: "/frequently-asked-questions",
  COMMUNITY_GUIDELINES: "/community-guidelines",
  PRIVACY_POLICY: "/privacy-policy",
  GRIEVANCE_POLICY: "/grievance-policy",
  COOKIE_POLICY: "/cookie-policy",
  TERMS_CONDITIONS: "/terms-and-conditions",
  PPI_TNC: "/ppi-terms-and-conditions",
  RUPEE_CIRCLE_TNC: "/rupee-circle-terms-and-conditions",
  CONTACT_US: "/contact-us",
  TRANSCORP_TNC: "/transcorp-terms-and-conditions",
  PAYMENTS: "/payments",
  NOT_FOUND: "/not-found",
  ADITI_INVESTMENT_PLAN: "/aditi-investment-plan",
  RUPEE_CIRCLE_LOGIN: "https://www.rupeecircle.com/login",
};

export default Routes;
